import ProductsTestShack from "@/pages/products/test-shack/m2";
import ProductsTestShackReport from "@/pages/products/test-shack/m2/report";
import {
	ProductsTestShackManager,
	ProductsTestShackManagerShift,
} from "@/pages/products/test-shack/manager";
import ProductsTestShackSheet from "@/pages/products/test-shack/m2/sheet";
import { M1TestShackPage } from "@/pages/products/test-shack/m1";
import {
	M1TestShackManager,
	M1TestShackManagerShift,
} from "@/pages/products/test-shack/m1/manager";
import M1TestShackSheet from "@/pages/products/test-shack/m1/sheet";
import M1TestShackReport from "@/pages/products/test-shack/m1/report";
import { MILL_1 } from "../mill-config/mill-config";

export const routeProductsTestShack = "/products/test-shack";
export const routeProductsTestShackReport = "/products/test-shack/report";
export const routeProductsTestShackManager = "/products/test-shack/manager";
export const routeProductsTestShackSheet = "/products/test-shack/sheet";
export const productsTestShackPermission = "ui.navbar.products.test.shack";
export const productsTestShackReportPermission =
	"ui.navbar.products.test.shack.report";
export const productsTestShackManagerPermission =
	"ui.navbar.products.test.shack.manager";

export const routeM1TestShack = "/products/m1/test-shack";
export const routeM1TestShackReport = `${routeM1TestShack}/report`;
export const routeM1TestShackManager = `${routeM1TestShack}/manager`;
export const routeM1TestShackSheet = `${routeM1TestShack}/sheet`;
export const m1TestShackPermission = "ui.navbar.products.m1.test.shack";
export const m1TestShackReportPermission =
	"ui.navbar.products.m1.test.shack.report";
export const m1TestShackManagerPermission =
	"ui.navbar.products.m1.test.shack.manager";

export const productsM1Routes = [
	{
		path: routeM1TestShack,
		element: <M1TestShackPage assetId={MILL_1.id} />,
		permission: m1TestShackPermission,
	},
	{
		path: routeM1TestShackReport,
		element: <M1TestShackReport />,
		permission: m1TestShackReportPermission,
	},
	{
		path: routeM1TestShackManager,
		element: <M1TestShackManager />,
		permission: m1TestShackManagerPermission,
	},
	{
		path: `${routeM1TestShackManager}/:shiftId`,
		element: <M1TestShackManagerShift />,
		permission: m1TestShackManagerPermission,
	},
	{
		path: `${routeM1TestShackSheet}/:profileInspectionId`,
		element: <M1TestShackSheet />,
		permission: m1TestShackManagerPermission,
	},
];

export const productsRoutes = [
	{
		path: routeProductsTestShack,
		element: <ProductsTestShack />,
		permission: productsTestShackPermission,
	},
	{
		path: routeProductsTestShackReport,
		element: <ProductsTestShackReport />,
		permission: productsTestShackReportPermission,
	},
	{
		path: routeProductsTestShackManager,
		element: <ProductsTestShackManager />,
		permission: productsTestShackManagerPermission,
	},
	{
		path: `${routeProductsTestShackManager}/:shiftId`,
		element: <ProductsTestShackManagerShift />,
		permission: productsTestShackManagerPermission,
	},
	{
		path: `${routeProductsTestShackSheet}/:profileInspectionId`,
		element: <ProductsTestShackSheet />,
		permission: productsTestShackManagerPermission,
	},
];
